export const selectAccountsList = (state) => state.accounts.accounts;
export const selectAccountsLoading = (state) => state.accounts.loading;
export const selectAccountsError = (state) => state.accounts.error;
export const selectAccountsSuccessMessage = (state) => state.accounts.successMessage;
